module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-ad-card"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/adcard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By the same author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-introduction"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-preface004"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/preface004"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter000"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter000"
    }
  }, [_vm._v("1. Written in Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("2. The American Occupation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Papa Doc Comes to Power")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Papa Doc, President")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Height of the Terror")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Papa Doc’s Final Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Revolution Continues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Jeanclaudism, 1977–79")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Jean-Claude and Michéle, Honeymoon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Dynasty Falters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Final Days of Duvalier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Legacy: Duvalierism Without Duvalier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Passages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Tempests")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-appendix001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-illustration"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/illustration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustration Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-sources"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources for Chapters 1-13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-bibliography"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-endnotes"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-index"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 69
// module chunks = 0